// Module
var code = `<div class="disable-portal"></div> `;
// Exports
export default code;